import { render, staticRenderFns } from "./testSubBox.vue?vue&type=template&id=6d95df40&scoped=true&"
import script from "./testSubBox.vue?vue&type=script&lang=js&"
export * from "./testSubBox.vue?vue&type=script&lang=js&"
import style0 from "./testSubBox.vue?vue&type=style&index=0&id=6d95df40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d95df40",
  null
  
)

export default component.exports